import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type GetImageClassificationV1ExploreClassificationsClassificationIdGetData,
  type GetImageClassificationV1ExploreClassificationsClassificationIdGetError,
  type GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse,
  getImageClassificationV1ExploreClassificationsClassificationIdGet,
} from '../../generated';

export type GetImageClassificationQueryVariables =
  GetImageClassificationV1ExploreClassificationsClassificationIdGetData['path'];

export type GetImageClassificationQuery = GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse;

export const useGetImageClassificationQuery = <
  TData = GetImageClassificationQuery,
  TError = GetImageClassificationV1ExploreClassificationsClassificationIdGetError,
>(
  { classification_id }: GetImageClassificationQueryVariables,
  options?: Omit<UseQueryOptions<GetImageClassificationQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<GetImageClassificationQuery, TError, TData>({
    queryKey: ['GetImageClassification', { classification_id }],
    queryFn: async () => {
      const { data } = await getImageClassificationV1ExploreClassificationsClassificationIdGet({
        path: { classification_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useGetImageClassificationQuery.getKey = ({ classification_id }: GetImageClassificationQueryVariables) => [
  'GetImageClassification',
  { classification_id },
];

useGetImageClassificationQuery.fetcher = (
  { classification_id }: GetImageClassificationQueryVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await getImageClassificationV1ExploreClassificationsClassificationIdGet({
      path: { classification_id },
      throwOnError: true,
    });
    return data;
  };
};
